import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { ReactQueryProviderWrapper } from "@quest/react-query-provider";
import { ReduxProviderWrapper } from "@quest/redux-provider";
import "@quest/ui/styles/globals.css";
import "@/config/i18nConfig.tsx";
import "@quest/i18nConfig";
import { ToastContainer } from "react-toastify";

createRoot(document.getElementById("root")!).render(
  <>
    <ReduxProviderWrapper>
      <ReactQueryProviderWrapper>
        <App />
        <ToastContainer />
      </ReactQueryProviderWrapper>
    </ReduxProviderWrapper>
  </>
);
